import { createFileRoute, Navigate } from '@tanstack/react-router';

/** The intakes are a stage of the one list of clients (ADR-037): an old address leads there. */
export const Route = createFileRoute('/intakes/')({ component: IntakesMoved });

function IntakesMoved() {
  return <Navigate to="/clients" search={{ status: 'intake' }} replace />;
}
